import React, { useContext } from 'react'
import InputColor from '../inputs/InputColor'
import ExportButton from './ExportButton'
import { ColorContext } from '../../contexts/ColorContext'
import LogoDropdown from '../logoOptions/LogoDropdown'
import { Link } from 'react-router-dom'

const Instructions = () => {
  const { colors } = useContext(ColorContext)
  return (
    <div className="instructions">
      <ol className="instructions-list">
        <li className="instructions-step">
          <strong>Enter details →</strong>
        </li>
        <li className="instructions-step">
          <strong>Pick colours</strong>
          <div className="instructions-step-content">
            <InputColor actionType="UPDATE_TEXT_COLOR" label="Text Colour" color={colors.textColor}/>
            <InputColor actionType="UPDATE_BACKGROUND_COLOR" label="Background Colour" color={colors.backgroundColor}/>
          </div>
        </li>
        <li className="instructions-step instructions-step-logo">
          <strong>Logo options</strong>
          <div className="instructions-step-content">
            <LogoDropdown />
          </div>
        </li>
        <li className="instructions-step instructions-step-export">
          <div className="instructions-step-group">
            <strong>Export background</strong>
            <div className="instructions-step-content">
              <ExportButton clientHasPaid={false} label="Free Download" watermark="(with watermark)" description="(with watermark)"/>
              <ExportButton clientHasPaid={false} label="Buy design: $5" name="zoomback Freelance" description="(no watermark)" amount={500}/>
              <ExportButton clientHasPaid={false} label="Buy template: $10" name="zoomback Company" description="(no watermark)" amount={1000}/>
            </div>
          </div>
          <div className="instructions-links">
            <Link to="/pricing"><small>Pricing</small></Link>
            <Link to="/about"><small>About zoomback</small></Link>
            <a href="https://support.zoom.us/hc/en-us/articles/210707503-Virtual-Background" target="_blank" rel="noopener noreferrer">
              <small>How to enable virtual background</small>
            </a>
          </div>
        </li>
      </ol>
    </div>
  )
}

export default Instructions
